import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import {
  PLATFORM_ID,
  REQUEST,
  TransferState,
  inject,
  makeStateKey
} from '@angular/core';

import { UtmService, UtmTransferPayload } from './utm.service';

export const UTM_TRANSFER_STATE_KEY =
  makeStateKey<UtmTransferPayload>('utm-transfer-payload');

export function utmTransferInitializer(): void | Promise<void> {
  const platformId = inject(PLATFORM_ID);
  const transferState = inject(TransferState);
  const request = inject(REQUEST, { optional: true });
  const utmService = inject(UtmService);

  if (isPlatformServer(platformId)) {
    const requestUrl = request?.url;
    if (!requestUrl) {
      return;
    }

    const baseUrl = 'http://localhost';
    let parsedUrl: URL;
    try {
      parsedUrl = new URL(requestUrl, baseUrl);
    } catch {
      return;
    }

    const utm_source = parsedUrl.searchParams.get('utm_source') ?? '';
    const utm_medium = parsedUrl.searchParams.get('utm_medium') ?? '';

    if (!utm_source && !utm_medium) {
      return;
    }

    transferState.set(UTM_TRANSFER_STATE_KEY, { utm_source, utm_medium });
    return;
  }

  if (isPlatformBrowser(platformId)) {
    const payload = transferState.get(UTM_TRANSFER_STATE_KEY, null);
    if (payload) {
      utmService.applyUtmFromTransferState(payload);
      transferState.remove(UTM_TRANSFER_STATE_KEY);
    } else {
      utmService.captureUTMFromUrl();
    }
  }
}

